module.exports = __webpack_public_path__ + "img/stickerfull.9ffeeeaa.jpg";